
import * as React from 'react';
import { useEffect, useState } from 'react';
import Sidenav from '../Sidenav/Sidenav';
import Navbar from '../Sidenav/Navbar';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Modal, Typography } from '@mui/material';import { db } from '../../../api/firebase'; // Adjust the import path as necessary
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

const Dashboard = () => {
  const [formData, setFormData] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // State to store the selected row's data
  const [openModal, setOpenModal] = useState(false); // State to control the modal

  // Fetch data from Firestore and sort by timestamp
  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, 'form'), orderBy('timestamp', 'desc')); // Sort by timestamp in descending order
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFormData(data);
    };

    fetchData();
  }, []);

  // Function to handle opening the modal with details
  const handleOpenDetails = (data) => {
    setSelectedData(data);
    setOpenModal(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedData(null);
  };

  return (
    <div className='bgcolor'>
      <Navbar />
      <Box height={70} />
      <Box sx={{ display: "flex" }}>
        <Sidenav />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Full Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Document Type</TableCell>
                  <TableCell>Target Audience</TableCell>
                  <TableCell>Desired Service</TableCell>
                  <TableCell>Deadline</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.map((data) => (
                  <TableRow key={data.id}>
                    <TableCell>{data.fullName}</TableCell>
                    <TableCell>{data.email}</TableCell>
                    <TableCell>{data.phone}</TableCell>
                    <TableCell>{data.documentType}</TableCell>
                    <TableCell>{data.targetAudience}</TableCell>
                    <TableCell>{data.desiredService}</TableCell>
                    <TableCell>{data.deadline}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleOpenDetails(data)}
                      >
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Modal to show all details */}
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}>
              <Typography id="modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                Submission Details
              </Typography>
              {selectedData && (
                <Box>
                  <Typography><strong>Full Name:</strong> {selectedData.fullName}</Typography>
                  <Typography><strong>Email:</strong> {selectedData.email}</Typography>
                  <Typography><strong>Phone:</strong> {selectedData.phone}</Typography>
                  <Typography><strong>Document Type:</strong> {selectedData.documentType}</Typography>
                  <Typography><strong>Word Count:</strong> {selectedData.wordCount}</Typography>
                  <Typography><strong>Subject Area:</strong> {selectedData.subjectArea}</Typography>
                  <Typography><strong>Target Audience:</strong> {selectedData.targetAudience}</Typography>
                  <Typography><strong>Desired Service:</strong> {selectedData.desiredService}</Typography>
                  <Typography><strong>Deadline:</strong> {selectedData.deadline}</Typography>
                  <Typography><strong>Instructions:</strong> {selectedData.instructions}</Typography>
                  {selectedData.fileUrl && (
                    <Button
                      variant="contained"
                      color="primary"
                      href={selectedData.fileUrl}
                      target="_blank"
                      download
                      sx={{ mt: 2 }}
                    >
                      Download File
                    </Button>
                  )}
                </Box>
              )}
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCloseModal}
                sx={{ mt: 2 }}
              >
                Close
              </Button>
            </Box>
          </Modal>
        </Box>
      </Box>
    </div>
  );
};

export default Dashboard;

// import * as React from 'react';
//  import Sidenav from '../Sidenav/Sidenav';
// import Navbar from '../Sidenav/Navbar';
// import { Box } from '@mui/material';
 
 
 
// const Dashboard = () => { // Component name starts with an uppercase letter
 

//    const name_company = localStorage.getItem("username");

  

//   return (
//     <div className='bgcolor'>
//       <Navbar />
//       <Box height={70} />

//       <Box sx={{ display: "flex" }}>
//         <Sidenav />

 
//       </Box>
//     </div>
//   );
// };

// export default Dashboard; // Export as default

 